import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import DesignDevelopment from "@/components/DesignDevelopment";
import DataCenter from "@/components/DataCenter";
import CloudServices from "@/components/CloudServices";
import MarketConsulting from "@/components/MarketConsulting";
import WhyChooseUs from "@/components/WhyChooseUs";
import Clients from "@/components/Clients";
import CTA from "@/components/CTA";
import Footer from "@/components/Footer";
import LogoShowcase from "@/components/LogoShowcase";
import ContactPage from "@/components/ContactPage";
import BlogList from "@/components/BlogList";
import BlogPost from "@/components/BlogPost";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminDashboard from "@/components/admin/AdminDashboard";
import AdminContacts from "@/components/admin/AdminContacts";
import { Toaster } from "@/components/ui/toaster";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <DesignDevelopment />
      <DataCenter />
      <CloudServices />
      <MarketConsulting />
      <WhyChooseUs />
      {/* <Clients /> */}
      <CTA />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/logo-options" element={<LogoShowcase />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="contacts" element={<AdminContacts />} />
            <Route path="posts" element={<div className="p-8 text-center text-gray-500">Posts management coming soon...</div>} />
            <Route path="media" element={<div className="p-8 text-center text-gray-500">Media library coming soon...</div>} />
            <Route path="categories" element={<div className="p-8 text-center text-gray-500">Categories management coming soon...</div>} />
            <Route path="settings" element={<div className="p-8 text-center text-gray-500">Settings coming soon...</div>} />
          </Route>
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
